import request from '@/api'

const baseUrl = '/upload'

// 用户相关API
export const uploadApi = {
  // 上传文件
  uploadImage(image, onProgress) {
    const formData = new FormData();
    formData.append('image', image);

    return request({
      url: `${baseUrl}/image`,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onProgress
    });
  },
  // 文件上传
  uploadFile(file, onProgress) {
    const formData = new FormData();
    formData.append('file', file);

    return request({
      url: `${baseUrl}/file`,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: onProgress
    });
  },
}